import { PermissionLevel } from '@/utils/permission';
export const transportRoutes = [
  {
    component: () => import('@/pages/masterdata/transportcompanies/index.vue'),
    meta: {
      permissions: [{ TransportCompany: PermissionLevel.Read }],
      title: 'menu_transport_companies'
    },
    name: 'TransportCompanies',
    path: 'transport-companies'
  },
  {
    component: () => import('@/pages/masterdata/transportcompanies/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ TransportCompany: PermissionLevel.Write }],
      title: 'createTransportCompany'
    },
    name: 'CreateTransportCompany',
    path: 'transport-companies/create'
  },
  {
    component: () => import('@/pages/masterdata/transportcompanies/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ TransportCompany: PermissionLevel.Read }],
      title: 'editTransportCompany'
    },
    name: 'EditTransportCompany',
    path: 'transport-companies/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/transportroutes/index.vue'),
    meta: {
      permissions: [{ TransportRoute: PermissionLevel.Read }],
      title: 'menu_transport_routes'
    },
    name: 'TransportRoutes',
    path: 'transport-routes'
  },
  {
    component: () => import('@/pages/masterdata/transportroutes/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ TransportRoute: PermissionLevel.Write }],
      title: 'createTransportRoute'
    },
    name: 'CreateTransportRoute',
    path: 'transport-routes/create'
  },
  {
    component: () => import('@/pages/masterdata/transportroutes/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ TransportRoute: PermissionLevel.Read }],
      title: 'editTransportRoute'
    },
    name: 'EditTransportRoute',
    path: 'transport-routes/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/shipmentlisttypes/index.vue'),
    meta: {
      permissions: [{ ShipmentListType: PermissionLevel.Read }],
      title: 'menu_shipment_list_types'
    },
    name: 'ShipmentListTypes',
    path: 'shipment-list-types'
  },
  {
    component: () => import('@/pages/masterdata/shipmentlisttypes/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ ShipmentListType: PermissionLevel.Write }],
      title: 'createShipmentListType'
    },
    name: 'CreateShipmentListType',
    path: 'shipment-list-types/create'
  },
  {
    component: () => import('@/pages/masterdata/shipmentlisttypes/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ ShipmentListType: PermissionLevel.Read }],
      title: 'editShipmentListType'
    },
    name: 'EditShipmentListType',
    path: 'shipment-list-types/edit/:id(\\d+)'
  },

  {
    component: () => import('@/pages/masterdata/trucks/index.vue'),
    meta: {
      permissions: [{ Truck: PermissionLevel.Read }],
      title: 'menu_trucks'
    },
    name: 'Trucks',
    path: 'trucks'
  },
  {
    component: () => import('@/pages/masterdata/trucks/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ Truck: PermissionLevel.Write }],
      title: 'createTruck'
    },
    name: 'CreateTruck',
    path: 'trucks/create'
  },
  {
    component: () => import('@/pages/masterdata/trucks/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ Truck: PermissionLevel.Read }],
      title: 'editTruck'
    },
    name: 'EditTruck',
    path: 'trucks/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/parceltypes/index.vue'),
    meta: {
      permissions: [{ ParcelType: PermissionLevel.Read }],
      title: 'menu_parcel_types'
    },
    name: 'ParcelTypes',
    path: 'parcel-types'
  },
  {
    component: () => import('@/pages/masterdata/parceltypes/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ ParcelType: PermissionLevel.Write }],
      title: 'createParcelType'
    },
    name: 'CreateParcelType',
    path: 'parcel-types/create'
  },
  {
    component: () => import('@/pages/masterdata/parceltypes/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ ParcelType: PermissionLevel.Read }],
      title: 'editParcelType'
    },
    name: 'EditParcelType',
    path: 'parcel-types/edit/:id(\\d+)'
  }
];
